import { render, staticRenderFns } from "./CustomPage.vue?vue&type=template&id=3f2d7480&scoped=true"
import script from "./CustomPage.vue?vue&type=script&lang=js"
export * from "./CustomPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d7480",
  null
  
)

export default component.exports